// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plots – shared styling for Analytics charts & tables
   Targeted for "Monthly Total Insects Trapped (by Client)"
   ------------------------------------------------------------------ */
   :root {
    --plot-blue-900: #0b3b70;   /* header blue */
    --plot-blue-200: #dce6f5;   /* light band / footer cells */
    --plot-blue-100: #e9f0f9;   /* zebra alt */
    --plot-grid:     #e5edf6;   /* chart gridlines */
    --plot-text:     #334155;   /* slate-700 */
    --plot-muted:    #64748b;   /* slate-500 */
    --plot-border:   #dce6f5;
    
  }
  
  /* ------------ Chart (Recharts) ------------ */
  /* Make charts look like the screenshot when used in Section 2 */
  .acnt__panel--chart .recharts-wrapper {
    font-size: 12px;
    color: var(--plot-text);
  }
  
  /* Horizontal grid only, soft blue */
  .acnt__panel--chart .recharts-cartesian-grid-horizontal line {
    stroke: var(--plot-grid);
  }
  .acnt__panel--chart .recharts-cartesian-grid-vertical line {
    display: none;
  }
  
  /* Axis label styling */
  .acnt__panel--chart .recharts-xAxis .recharts-cartesian-axis-tick-value,
  .acnt__panel--chart .recharts-yAxis .recharts-cartesian-axis-tick-value {
    fill: var(--plot-muted);
    font-size: 12px;
  }
  
  /* Legend at bottom, compact, muted label color */
  .acnt__panel--chart .recharts-legend-wrapper {
    margin-top: 6px;
  }
  .acnt__panel--chart .recharts-legend-item-text {
    color: var(--plot-muted);
    font-size: 12px;
  }
  
  /* Tooltip text color */
  .acnt__panel--chart .recharts-default-tooltip {
    font-size: 12px;
    color: var(--plot-text);
  }
  
  /* ------------ Table (Total by Client) ------------ */
  .anl-ttc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid var(--plot-border);
    border-radius: 8px;
    overflow: hidden; /* keep rounded corners */
  }
  
  /* Header: deep blue bar with white text, column dividers */
  .anl-ttc-table thead tr {
    background: var(--plot-blue-900);
    color: #fff;
  }
  .anl-ttc-table thead th {
    padding: 10px 12px;
    font-weight: 700;
    border-bottom: 1px solid var(--plot-blue-900);
  }
  .anl-ttc-table thead th:not(:last-child) {
    border-right: 1px solid #ffffff;
  }
  
  /* Body rows: subtle zebra with right-aligned numbers */
  .anl-ttc-table tbody tr:nth-child(odd)  { background: var(--plot-blue-100); }
  .anl-ttc-table tbody tr:nth-child(even) { background: #f3f6fb; }
  
  .anl-ttc-table td {
    padding: 8px 12px;
    border-bottom: 1px solid var(--plot-border);
    border-right: 1px solid var(--plot-border);
    font-variant-numeric: tabular-nums;
  }
  .anl-ttc-table td.col-number { text-align: right; }
  .anl-ttc-table td.col-species { font-weight: 600; text-align: left; white-space: nowrap; }
  
  /* Last column "Total (per Species)" — bold and blue to match screenshot */
  .anl-ttc-table tbody td:last-child {
    font-weight: 700;
    color: var(--plot-blue-900);
  }
  
  /* Footer: left cell deep blue, other cells light blue with bold numbers */
  .anl-ttc-table tfoot td {
    padding: 10px 12px;
    border-right: 1px solid var(--plot-border);
    font-weight: 700;
  }
  .anl-ttc-table tfoot td:first-child {
    background: var(--plot-blue-900);
    color: #fff;
  }
  .anl-ttc-table tfoot td:not(:first-child) {
    background: var(--plot-blue-200);
    text-align: right;
  }
  
  /* Slightly tighter table spacing on small screens */
  @media (max-width: 768px) {
    .anl-ttc-table { font-size: 13px; }
    .anl-ttc-table thead th, .anl-ttc-table td { padding: 6px 8px; }
  }
  
  /* Tighter row height */
.anl-ttc-table {
    font-size: 13px;              /* slightly smaller text */
    line-height: 1.2;             /* reduce line height */
  }
  
  .anl-ttc-table th,
  .anl-ttc-table td {
    padding: 4px 8px;             /* was 10px 12px (or 6px 8px) */
    vertical-align: middle;       /* prevent extra top/bottom space */
  }
  /* Compact header row for all analysis tables */
.anl-ttc-table thead th {
    padding: 4px 6px !important;   /* reduce from 10px/12px */
    font-size: 13px;               /* slightly smaller text */
    line-height: 1.2;              /* tighter row height */
    vertical-align: middle;
  }
  
  
  /* Optional: even tighter on very small screens */
  @media (max-width: 768px) {
    .anl-ttc-table {
      font-size: 12px;
      line-height: 1.15;
    }
    .anl-ttc-table th,
    .anl-ttc-table td {
      padding: 3px 6px;
    }
  }
  
  /* Dense mode */
.anl-ttc-table--dense th,
.anl-ttc-table--dense td {
  padding: 3px 6px;
  line-height: 1.1;
  font-size: 12.5px;
}

/* ---- Make the entire Total (Monthly) row a uniform light blue ---- */
.anl-ttc-table tfoot tr td {
    background: var(--plot-blue-200) !important; /* same blue for all cells */
    color: var(--plot-text);
    font-weight: 700;
    text-align: right;           /* numbers align right */
    padding: 8px 12px;
    border-right: 1px solid var(--plot-border);
  }
  
  /* Left-most "Total (Monthly)" label cell: same blue + left align */
  .anl-ttc-table tfoot tr td:first-child {
    text-align: left;
    /* remove any previous dark-blue rule */
    background: var(--plot-blue-200) !important;
    color: var(--plot-text) !important;
    border-right: 1px solid var(--plot-border);
  }
  
  /* Footer rows for TrendByArea / TotalByClient */

/* Blue "Total (Monthly)" row across ALL cells */
.anl-ttc-table tfoot tr.anl-total-row td {
    background: var(--plot-blue-200) !important;
    color: var(--plot-text);
    font-weight: 700;
    text-align: right;
  }
  .anl-ttc-table tfoot tr.anl-total-row td:first-child {
    text-align: left;
  }
  
  /* Red "Threshold (Monthly)" row with white background and red text */
  .anl-ttc-table tfoot tr.anl-threshold-row td {
    background: #ffffff !important;
    color: #d32f2f !important;
    font-weight: 700;
    text-align: right;
  }
  .anl-ttc-table tfoot tr.anl-threshold-row td:first-child {
    text-align: left;
  }

  /* Uniform compact row height for ALL analysis tables */
.anl-ttc-table th,
.anl-ttc-table td {
  padding: 4px 6px !important;   /* same padding for header, body, footer */
  font-size: 13px;               /* uniform font size */
  line-height: 1.3;              /* tighter vertical spacing */
  vertical-align: middle;
}

  
/* Total (Monthly) row */
.anl-ttc-table tfoot tr.anl-total-row td {
    background: var(--plot-blue-200) !important;
    color: var(--plot-blue-900) !important; /* dark blue text */
    font-weight: 700;
    text-align: right;
    padding: 4px 6px;
  }
  .anl-ttc-table tfoot tr.anl-total-row td:first-child {
    text-align: left;
  }
  
  /* Threshold (Monthly) row */
  .anl-ttc-table tfoot tr.anl-threshold-row td {
    background: var(--plot-blue-200) !important; /* same background as Total */
    color: #d32f2f !important;                  /* red text */
    font-weight: 700;
    text-align: right;
    padding: 4px 6px;
  }
  .anl-ttc-table tfoot tr.anl-threshold-row td:first-child {
    text-align: left;
  }
  
  /* Multi-line trend charts (4th analysis) */
.plot-lines .recharts-wrapper { font-size: 12px; }
.plot-lines .recharts-cartesian-grid-vertical line { display: none; }
.plot-lines .recharts-cartesian-grid-horizontal line { stroke: var(--plot-grid); }
.plot-lines .recharts-legend-wrapper { margin-top: 6px; }
.plot-lines .recharts-legend-item-text,
.plot-lines .recharts-xAxis .recharts-cartesian-axis-tick-value,
.plot-lines .recharts-yAxis .recharts-cartesian-axis-tick-value {
  fill: var(--plot-muted);
}

/* Left-align only the first header cell */
.anl-table thead th:first-child {
  text-align: left;
  padding-left: 8px;
}

/* Right-align all other header cells */
.anl-table thead th:not(:first-child) {
  text-align: right;
  padding-right: 8px;
}

/* Ensure body cells follow the same pattern */
.anl-table tbody td:first-child {
  text-align: left;
  padding-left: 8px;
}

.anl-table tbody td:not(:first-child),
.anl-table tfoot td:not(:first-child) {
  text-align: right;
  padding-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/analytics/plots/plots.css"],"names":[],"mappings":"AAAA;;uEAEuE;GACpE;IACC,wBAAwB,IAAI,gBAAgB;IAC5C,wBAAwB,IAAI,8BAA8B;IAC1D,wBAAwB,IAAI,cAAc;IAC1C,wBAAwB,IAAI,oBAAoB;IAChD,wBAAwB,IAAI,cAAc;IAC1C,wBAAwB,IAAI,cAAc;IAC1C,wBAAwB;;EAE1B;;EAEA,+CAA+C;EAC/C,gEAAgE;EAChE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;;EAEA,uBAAuB;EACvB;;IAEE,uBAAuB;IACvB,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA,sDAAsD;EACtD;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB,EAAE,yBAAyB;EAC7C;;EAEA,2DAA2D;EAC3D;IACE,gCAAgC;IAChC,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;EAC/C;EACA;IACE,+BAA+B;EACjC;;EAEA,uDAAuD;EACvD,0CAA0C,gCAAgC,EAAE;EAC5E,0CAA0C,mBAAmB,EAAE;;EAE/D;IACE,iBAAiB;IACjB,2CAA2C;IAC3C,0CAA0C;IAC1C,kCAAkC;EACpC;EACA,+BAA+B,iBAAiB,EAAE;EAClD,gCAAgC,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;EAEzF,0EAA0E;EAC1E;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA,0EAA0E;EAC1E;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,WAAW;EACb;EACA;IACE,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA,oDAAoD;EACpD;IACE,iBAAiB,eAAe,EAAE;IAClC,6CAA6C,gBAAgB,EAAE;EACjE;;EAEA,uBAAuB;AACzB;IACI,eAAe,eAAe,0BAA0B;IACxD,gBAAgB,cAAc,uBAAuB;EACvD;;EAEA;;IAEE,gBAAgB,cAAc,+BAA+B;IAC7D,sBAAsB,QAAQ,mCAAmC;EACnE;EACA,+CAA+C;AACjD;IACI,2BAA2B,IAAI,0BAA0B;IACzD,eAAe,gBAAgB,0BAA0B;IACzD,gBAAgB,eAAe,uBAAuB;IACtD,sBAAsB;EACxB;;;EAGA,iDAAiD;EACjD;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;IACA;;MAEE,gBAAgB;IAClB;EACF;;EAEA,eAAe;AACjB;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;IACI,2CAA2C,EAAE,4BAA4B;IACzE,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB,YAAY,wBAAwB;IACrD,iBAAiB;IACjB,0CAA0C;EAC5C;;EAEA,mEAAmE;EACnE;IACE,gBAAgB;IAChB,uCAAuC;IACvC,2CAA2C;IAC3C,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA,gDAAgD;;AAElD,gDAAgD;AAChD;IACI,2CAA2C;IAC3C,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;;EAEA,uDAAuD;AACzD;;EAEE,2BAA2B,IAAI,0CAA0C;EACzE,eAAe,gBAAgB,sBAAsB;EACrD,gBAAgB,eAAe,6BAA6B;EAC5D,sBAAsB;AACxB;;;AAGA,wBAAwB;AACxB;IACI,2CAA2C;IAC3C,sCAAsC,EAAE,mBAAmB;IAC3D,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,2CAA2C,EAAE,6BAA6B;IAC1E,yBAAyB,mBAAmB,aAAa;IACzD,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA,2CAA2C;AAC7C,gCAAgC,eAAe,EAAE;AACjD,qDAAqD,aAAa,EAAE;AACpE,uDAAuD,wBAAwB,EAAE;AACjF,uCAAuC,eAAe,EAAE;AACxD;;;EAGE,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Plots – shared styling for Analytics charts & tables\n   Targeted for \"Monthly Total Insects Trapped (by Client)\"\n   ------------------------------------------------------------------ */\n   :root {\n    --plot-blue-900: #0b3b70;   /* header blue */\n    --plot-blue-200: #dce6f5;   /* light band / footer cells */\n    --plot-blue-100: #e9f0f9;   /* zebra alt */\n    --plot-grid:     #e5edf6;   /* chart gridlines */\n    --plot-text:     #334155;   /* slate-700 */\n    --plot-muted:    #64748b;   /* slate-500 */\n    --plot-border:   #dce6f5;\n    \n  }\n  \n  /* ------------ Chart (Recharts) ------------ */\n  /* Make charts look like the screenshot when used in Section 2 */\n  .acnt__panel--chart .recharts-wrapper {\n    font-size: 12px;\n    color: var(--plot-text);\n  }\n  \n  /* Horizontal grid only, soft blue */\n  .acnt__panel--chart .recharts-cartesian-grid-horizontal line {\n    stroke: var(--plot-grid);\n  }\n  .acnt__panel--chart .recharts-cartesian-grid-vertical line {\n    display: none;\n  }\n  \n  /* Axis label styling */\n  .acnt__panel--chart .recharts-xAxis .recharts-cartesian-axis-tick-value,\n  .acnt__panel--chart .recharts-yAxis .recharts-cartesian-axis-tick-value {\n    fill: var(--plot-muted);\n    font-size: 12px;\n  }\n  \n  /* Legend at bottom, compact, muted label color */\n  .acnt__panel--chart .recharts-legend-wrapper {\n    margin-top: 6px;\n  }\n  .acnt__panel--chart .recharts-legend-item-text {\n    color: var(--plot-muted);\n    font-size: 12px;\n  }\n  \n  /* Tooltip text color */\n  .acnt__panel--chart .recharts-default-tooltip {\n    font-size: 12px;\n    color: var(--plot-text);\n  }\n  \n  /* ------------ Table (Total by Client) ------------ */\n  .anl-ttc-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n    border: 1px solid var(--plot-border);\n    border-radius: 8px;\n    overflow: hidden; /* keep rounded corners */\n  }\n  \n  /* Header: deep blue bar with white text, column dividers */\n  .anl-ttc-table thead tr {\n    background: var(--plot-blue-900);\n    color: #fff;\n  }\n  .anl-ttc-table thead th {\n    padding: 10px 12px;\n    font-weight: 700;\n    border-bottom: 1px solid var(--plot-blue-900);\n  }\n  .anl-ttc-table thead th:not(:last-child) {\n    border-right: 1px solid #ffffff;\n  }\n  \n  /* Body rows: subtle zebra with right-aligned numbers */\n  .anl-ttc-table tbody tr:nth-child(odd)  { background: var(--plot-blue-100); }\n  .anl-ttc-table tbody tr:nth-child(even) { background: #f3f6fb; }\n  \n  .anl-ttc-table td {\n    padding: 8px 12px;\n    border-bottom: 1px solid var(--plot-border);\n    border-right: 1px solid var(--plot-border);\n    font-variant-numeric: tabular-nums;\n  }\n  .anl-ttc-table td.col-number { text-align: right; }\n  .anl-ttc-table td.col-species { font-weight: 600; text-align: left; white-space: nowrap; }\n  \n  /* Last column \"Total (per Species)\" — bold and blue to match screenshot */\n  .anl-ttc-table tbody td:last-child {\n    font-weight: 700;\n    color: var(--plot-blue-900);\n  }\n  \n  /* Footer: left cell deep blue, other cells light blue with bold numbers */\n  .anl-ttc-table tfoot td {\n    padding: 10px 12px;\n    border-right: 1px solid var(--plot-border);\n    font-weight: 700;\n  }\n  .anl-ttc-table tfoot td:first-child {\n    background: var(--plot-blue-900);\n    color: #fff;\n  }\n  .anl-ttc-table tfoot td:not(:first-child) {\n    background: var(--plot-blue-200);\n    text-align: right;\n  }\n  \n  /* Slightly tighter table spacing on small screens */\n  @media (max-width: 768px) {\n    .anl-ttc-table { font-size: 13px; }\n    .anl-ttc-table thead th, .anl-ttc-table td { padding: 6px 8px; }\n  }\n  \n  /* Tighter row height */\n.anl-ttc-table {\n    font-size: 13px;              /* slightly smaller text */\n    line-height: 1.2;             /* reduce line height */\n  }\n  \n  .anl-ttc-table th,\n  .anl-ttc-table td {\n    padding: 4px 8px;             /* was 10px 12px (or 6px 8px) */\n    vertical-align: middle;       /* prevent extra top/bottom space */\n  }\n  /* Compact header row for all analysis tables */\n.anl-ttc-table thead th {\n    padding: 4px 6px !important;   /* reduce from 10px/12px */\n    font-size: 13px;               /* slightly smaller text */\n    line-height: 1.2;              /* tighter row height */\n    vertical-align: middle;\n  }\n  \n  \n  /* Optional: even tighter on very small screens */\n  @media (max-width: 768px) {\n    .anl-ttc-table {\n      font-size: 12px;\n      line-height: 1.15;\n    }\n    .anl-ttc-table th,\n    .anl-ttc-table td {\n      padding: 3px 6px;\n    }\n  }\n  \n  /* Dense mode */\n.anl-ttc-table--dense th,\n.anl-ttc-table--dense td {\n  padding: 3px 6px;\n  line-height: 1.1;\n  font-size: 12.5px;\n}\n\n/* ---- Make the entire Total (Monthly) row a uniform light blue ---- */\n.anl-ttc-table tfoot tr td {\n    background: var(--plot-blue-200) !important; /* same blue for all cells */\n    color: var(--plot-text);\n    font-weight: 700;\n    text-align: right;           /* numbers align right */\n    padding: 8px 12px;\n    border-right: 1px solid var(--plot-border);\n  }\n  \n  /* Left-most \"Total (Monthly)\" label cell: same blue + left align */\n  .anl-ttc-table tfoot tr td:first-child {\n    text-align: left;\n    /* remove any previous dark-blue rule */\n    background: var(--plot-blue-200) !important;\n    color: var(--plot-text) !important;\n    border-right: 1px solid var(--plot-border);\n  }\n  \n  /* Footer rows for TrendByArea / TotalByClient */\n\n/* Blue \"Total (Monthly)\" row across ALL cells */\n.anl-ttc-table tfoot tr.anl-total-row td {\n    background: var(--plot-blue-200) !important;\n    color: var(--plot-text);\n    font-weight: 700;\n    text-align: right;\n  }\n  .anl-ttc-table tfoot tr.anl-total-row td:first-child {\n    text-align: left;\n  }\n  \n  /* Red \"Threshold (Monthly)\" row with white background and red text */\n  .anl-ttc-table tfoot tr.anl-threshold-row td {\n    background: #ffffff !important;\n    color: #d32f2f !important;\n    font-weight: 700;\n    text-align: right;\n  }\n  .anl-ttc-table tfoot tr.anl-threshold-row td:first-child {\n    text-align: left;\n  }\n\n  /* Uniform compact row height for ALL analysis tables */\n.anl-ttc-table th,\n.anl-ttc-table td {\n  padding: 4px 6px !important;   /* same padding for header, body, footer */\n  font-size: 13px;               /* uniform font size */\n  line-height: 1.3;              /* tighter vertical spacing */\n  vertical-align: middle;\n}\n\n  \n/* Total (Monthly) row */\n.anl-ttc-table tfoot tr.anl-total-row td {\n    background: var(--plot-blue-200) !important;\n    color: var(--plot-blue-900) !important; /* dark blue text */\n    font-weight: 700;\n    text-align: right;\n    padding: 4px 6px;\n  }\n  .anl-ttc-table tfoot tr.anl-total-row td:first-child {\n    text-align: left;\n  }\n  \n  /* Threshold (Monthly) row */\n  .anl-ttc-table tfoot tr.anl-threshold-row td {\n    background: var(--plot-blue-200) !important; /* same background as Total */\n    color: #d32f2f !important;                  /* red text */\n    font-weight: 700;\n    text-align: right;\n    padding: 4px 6px;\n  }\n  .anl-ttc-table tfoot tr.anl-threshold-row td:first-child {\n    text-align: left;\n  }\n  \n  /* Multi-line trend charts (4th analysis) */\n.plot-lines .recharts-wrapper { font-size: 12px; }\n.plot-lines .recharts-cartesian-grid-vertical line { display: none; }\n.plot-lines .recharts-cartesian-grid-horizontal line { stroke: var(--plot-grid); }\n.plot-lines .recharts-legend-wrapper { margin-top: 6px; }\n.plot-lines .recharts-legend-item-text,\n.plot-lines .recharts-xAxis .recharts-cartesian-axis-tick-value,\n.plot-lines .recharts-yAxis .recharts-cartesian-axis-tick-value {\n  fill: var(--plot-muted);\n}\n\n/* Left-align only the first header cell */\n.anl-table thead th:first-child {\n  text-align: left;\n  padding-left: 8px;\n}\n\n/* Right-align all other header cells */\n.anl-table thead th:not(:first-child) {\n  text-align: right;\n  padding-right: 8px;\n}\n\n/* Ensure body cells follow the same pattern */\n.anl-table tbody td:first-child {\n  text-align: left;\n  padding-left: 8px;\n}\n\n.anl-table tbody td:not(:first-child),\n.anl-table tfoot td:not(:first-child) {\n  text-align: right;\n  padding-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
